import axios from "../../config/interceptor";
import { PER_PAGE_SIZE } from "../../utils/constants";

export const getBusinesProfileHandler = async (businesId, slug) => {
  try {
    let link =
      `/lambda/v1/business/business-profile?`;

    if (businesId) {
      link += `&id=${businesId}`;
    }
    if (slug) {
      link += `&slug=${slug}`;
    }

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const postBusinessProfileHandler = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/v1/business/business-profile`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getBusinessProfiles = async ({
  page = 0,
  size = PER_PAGE_SIZE,
  published = null,
}) => {
  try {
    let link =
      `/lambda/v1/business/business-profiles?`;

    link = link.concat("page=" + page);
    link = link.concat("&size=" + 999);
    if (process.env.REACT_APP_STAGING !== "true")
      link = link.concat("&published=" + true);

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const getBusinesOperatingHours = async (businesId) => {
  try {
    let link =
      `/lambda/v1/business/business-operating-hours/${businesId}`;

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const postBusinessOperatingHours = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/v1/business/business-operating-hours`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getBusinesAddress = async (businesId) => {
  try {
    let link =
      `/lambda/v1/business/business-address/${businesId}`;

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const postBusinessAddress = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/v1/business/business-address`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getBusinesDoctor = async (businesId) => {
  try {
    let link =
      `/lambda/v1/business/provider-schedules/${businesId}`;

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};
